import { flow as baseFlow } from '../mixins/flow';
/**
 * @type {{
	(...args: (string|string[])[]): string;
	calc: (...args: (string|string[])[]) => string;
}}
 */
// @ts-ignore We add calc below

export var flow = baseFlow;

flow.calc = function () {
  return "calc(" + baseFlow.apply(void 0, arguments) + ")";
};